import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import {
  findAllWebinaires,
  peutAccederAuxWebinaires,
} from "../services/webinaires.service";
import {
  PeutAccederAuxWebinairesResult,
  WebinairesResult,
} from "../interfaces/webinaires.interface";
import { ksUserQK, ksWebinairesQK } from "../query-keys";

type QueryOptions<T> = Omit<UseQueryOptions<T>, "queryKey" | "queryFn">;

export const usePeutAccederAuxWebinaires = (
  options?: QueryOptions<PeutAccederAuxWebinairesResult>
) =>
  useQuery({
    queryKey: [ksUserQK, "peut-acceder-aux-webinaires"],
    queryFn: peutAccederAuxWebinaires,
    ...options,
  });

export const useWebinaires = (options?: QueryOptions<WebinairesResult>) =>
  useQuery({
    queryKey: [ksWebinairesQK],
    queryFn: findAllWebinaires,
    ...options,
  });
